import clsx from 'clsx';
import React from 'react';
import {
  Dialog as ReactAriaDialog,
  type DialogProps,
  DialogTrigger as ReactAriaDialogTrigger,
  type DialogTriggerProps,
  Modal as ReactAriaModal,
  ModalOverlay as ReactAriaModalOverlay,
} from 'react-aria-components';

export interface ModalProps extends Omit<DialogTriggerProps, 'children'> {
  dialogTriggerElement?: DialogTriggerProps['children'];
  dialogProps?: Omit<DialogProps, 'children'> & React.RefAttributes<HTMLElement>;
  children?: DialogProps['children'];
}

export function Modal({ dialogTriggerElement, dialogProps, children, ...rest }: Readonly<ModalProps>) {
  return (
    <ReactAriaDialogTrigger {...rest}>
      {dialogTriggerElement}

      <ReactAriaModalOverlay
        className={({ isEntering, isExiting }) =>
          clsx(
            'fixed inset-0 z-10',
            'flex items-center justify-center',
            'min-h-full',
            'p-16',
            'bg-overlay-shade',
            isEntering && 'animate-fade-in',
            isExiting && 'animate-fade-out',
          )
        }
      >
        {/* "h-full relative" for 2 parent containers below */}
        {/* so the inner part can control scrolling behaviour */}
        <ReactAriaModal
          className={({ isEntering }) =>
            clsx('w-full h-full relative max-w-max-modal', isEntering && 'animate-zoom-in')
          }
        >
          <ReactAriaDialog className="w-full h-full relative outline-hidden" {...dialogProps}>
            {children}
          </ReactAriaDialog>
        </ReactAriaModal>
      </ReactAriaModalOverlay>
    </ReactAriaDialogTrigger>
  );
}
